




































































import { Component, Vue } from "vue-property-decorator";
import viewBox from "@/components/viewBox.vue";
import { Swipe, SwipeItem, Toast } from "vant";
import request from "@/api/index";
import store from "@/store/index";
@Component({
  components: { viewBox, vanSwipe: Swipe, vanSwipeItem: SwipeItem }
})
export default class Adopt extends Vue {
  selectIndex = 0;
  swipeIndex = 0;
  number = 0;
  selectList: Array<any> = [
    {
      img: require("../assets/images/adopt/shuixian.png"),
      id: 1
    },
    {
      img: require("../assets/images/adopt/yuanwei.png"),
      id: 2
    },
    {
      img: require("../assets/images/adopt/shuilian.png"),
      id: 3
    }
  ];
  list: any = [];
  detail: any = {};
  mounted() {
    document.title = "领养种子";
    this.getList();
    this.getnumber();
    if (this.$store.state.userseed.seedLevel != null) {
      Toast("当前账号已领取过种子");
      setTimeout(() => {
        this.$router.push("/cultivation");
      }, 2000);
    }
  }
  async getList() {
    const res = await request.getList();
    if (!res.code) {
      this.list = res.data;
    }
  }
  async getnumber() {
    const res = await request.getnumber();
    if (!res.code) {
      this.number = res.data;
    }
  }
  async getsaveseed() {
    const res = await request.getsaveseed(
      this.list[this.swipeIndex].id,
      this.selectList[this.selectIndex].id
    );
    if (!res.code) {
      Toast("领取种子成功");
      this.getseed();
    }
  }
  async getseed() {
    const res = await request.getseed();
    if (!res.code) {
      store.commit("SET_STATE", {
        userseed: res.data
      });
      setTimeout(() => {
        this.$router.push("/cultivation");
      }, 2000);
    }
  }

  checkswip(type: string) {
    if (type == "left") {
      (this.$refs["swipe"] as any).prev();
    }
    if (type == "right") {
      (this.$refs["swipe"] as any).next();
    }
  }
  onChange(index: number) {
    this.swipeIndex = index;
  }
  topage(path: string) {
    this.$router.push(path);
  }
}
